require('./cardsCancelPayLaterWizard.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');

//@components
const CardsCancelPayLaterInformationStep = require('./cardsCancelPayLaterInformationStep');
const CardsCancelPayLaterConfirmationStep = require('./cardsCancelPayLaterConfirmationStep');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @helpers
const { formatText } = require('core/i18n').i18n;

//@utilities
const currencyHelper = require('utilities/currencyHelper');

class CardsCancelPayLaterWizard extends React.Component {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
    }

    handleCancel() {
        this.props.history.push(`/myprofile/cards/${this.props.cardId}/movements`);
    }

    handleValidation(step) {
        this.props.onValidateStep(step);
    }

    buildInformativeList() {
        const { immCardCancelPayLaterInfo } = this.props;
        let informativeList;
        const cancelPayLaterInfo = immCardCancelPayLaterInfo.get('payLaterData');
        if (cancelPayLaterInfo && immCardCancelPayLaterInfo.size != 0) {
            const cancelPayLaterData = immCardCancelPayLaterInfo.get('payLaterData');
            const currency = cancelPayLaterData.get('currency');
            const currencySymbol = currencyHelper.formatCurrency(currency);
            const totalAmountToBePaidTitle = formatText('cardCancelPayLater-cardCancelPayLater_totalAmountToBePaid');
            const totalAmountToBePaid = cancelPayLaterData.getIn(['movements', '0', 'impopera']);
            const totalAmountToBePaidFormatted = `${currencyHelper.formatAmount(totalAmountToBePaid)} ${currencySymbol}`;

            informativeList = (
                <OKInformativeList>
                    <OKInformativeListItem
                        title={totalAmountToBePaidTitle}
                        bodyText={totalAmountToBePaidFormatted}
                />
                </OKInformativeList>
            )
        }

        return informativeList;
    }

    render() {
        const {
            cardId,
            finish,
            immCard,
            immCardCancelPayLater,
            onWillCancel,
            reset,
            setVisibleStep,
        } = this.props;
        const visibleStep = immCardCancelPayLater.get('visibleStep');
        const immSteps = immCardCancelPayLater.get('steps');
        const actions = {
            cancel: this.handleCancel,
            finish: finish,
            setVisibleStep: setVisibleStep,
            setWillCancel: onWillCancel,
            validateStep: this.handleValidation,
        };
        let informativeList = this.buildInformativeList();
        return (
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <Wizard
                                actions={actions}
                                immSteps={immSteps}
                                stepsAmount={immSteps.size}
                                visibleStep={visibleStep}
                                wizardClass="card-cancel-pay-later-wizard"
                            >
                                <WizardStep
                                    actions={actions}
                                    cancelButton={true}
                                    nextButton={true}
                                    position="first"
                                >
                                    <CardsCancelPayLaterInformationStep
                                        informativeList={informativeList}
                                    />
                                </WizardStep>
                                <WizardStep
                                    actions={actions}
                                    cancelButton={true}
                                    finalButtonDisabled={immCardCancelPayLater.get('isLoading')}
                                    finishButton={true}
                                    immFinalButton="cardCancelPayLater-cardCancelPayLater_finalButton"
                                    nextButton={true}
                                    position="last"
                                >
                                    <CardsCancelPayLaterConfirmationStep
                                        cardId={cardId}
                                        immCard={immCard}
                                        informativeList={informativeList}
                                        reset={reset}
                                    />
                                </WizardStep>
                            </Wizard>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CardsCancelPayLaterWizard.propTypes = {
    cardId: PropTypes.object.isRequired,
    finish: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    immCardCancelPayLater: PropTypes.object.isRequired,
    immCardCancelPayLaterInfo: PropTypes.object.isRequired,
    onValidateStep: PropTypes.func.isRequired,
    onWillCancel: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
};

module.exports = withRouter(CardsCancelPayLaterWizard);
